import type { AftercarePlan } from '../data/types';

export function planToMarkdown(plan: AftercarePlan): string {
  const lines: string[] = [];
  lines.push(`# ${plan.title}`);
  lines.push('');
  lines.push('## what you will need');
  for (const item of plan.items) lines.push(`- [ ] ${item}`);
  lines.push('');
  lines.push('## first 30 minutes');
  for (const step of plan.first30) lines.push(`- **${step.time}** — ${step.action}`);
  lines.push('');
  lines.push('## next few hours');
  for (const step of plan.nextHours) lines.push(`- **${step.time}** — ${step.action}`);
  lines.push('');
  lines.push('## for the next day or two');
  lines.push(plan.nextDays);
  lines.push('');
  lines.push(`_${plan.signature}_`);
  return lines.join('\n');
}

export function planToText(plan: AftercarePlan): string {
  // Same as markdown but without the markup decoration.
  const lines: string[] = [];
  lines.push(plan.title.toUpperCase());
  lines.push('');
  lines.push('WHAT YOU WILL NEED');
  for (const item of plan.items) lines.push(`  • ${item}`);
  lines.push('');
  lines.push('FIRST 30 MINUTES');
  for (const step of plan.first30) lines.push(`  ${step.time}: ${step.action}`);
  lines.push('');
  lines.push('NEXT FEW HOURS');
  for (const step of plan.nextHours) lines.push(`  ${step.time}: ${step.action}`);
  lines.push('');
  lines.push('FOR THE NEXT DAY OR TWO');
  lines.push(plan.nextDays);
  lines.push('');
  lines.push(plan.signature);
  return lines.join('\n');
}

export function downloadFile(filename: string, content: string, mime: string) {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }
  return false;
}
